import { Channel, ChannelType } from '../types';

const formatTitle = (chat: Channel, withoutName?: boolean) => {
  let title;

  if (chat?.channelType === ChannelType.TRANSACTION) {
    title = chat.title;
  } else if (chat?.application) {
    if (chat?.application?.companyName) {
      title = `Application (${chat?.application?.companyName})`;
    } else if (chat?.application?.firstName) {
      title = `Application (${chat?.application?.firstName} ${chat?.application?.lastName})`;
    }
  } else if (chat?.organization?.firstName) {
    title = `${chat?.organization?.firstName} ${chat?.organization?.lastName} (${chat.title})`;
  } else if (chat?.organization?.companyName) {
    title = `${chat?.organization?.companyName} (${chat.title})`;

    if (chat?.user?.profile?.firstName && !withoutName) {
      title = `${chat?.organization?.companyName} (${
        chat?.user?.profile?.firstName
      } ${chat?.user?.profile?.lastName || ''})`;
    }
  } else if (
    (chat?.organization &&
      !chat?.organization?.firstName &&
      !chat?.organization?.companyName) ||
    (chat?.channelType === ChannelType.MAIN &&
      !chat.organization &&
      !chat.application)
  ) {
    title = `${chat?.user?.profile?.firstName} ${chat?.user?.profile?.lastName} (${chat.title})`;
  } else if (chat?.channelType === ChannelType.DEMO) {
    title = `${chat.title} ${chat?.user ? `(${chat?.user?.phone})` : ''}`;
  }

  return title;
};

export default formatTitle;
